/**
 * Reusable inline loading spinner.
 * Uses the same animation as LoadingScreen but smaller and inline.
 */
export default function Spinner({ size = 24, message }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      gap: '0.75rem',
    }}>
      <div style={{
        width: `${size}px`,
        height: `${size}px`,
        border: '3px solid var(--border-color)',
        borderTopColor: 'var(--accent-primary)',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }} />
      {message && (
        <span style={{ color: 'var(--text-muted)', fontSize: '0.8125rem' }}>
          {message}
        </span>
      )}
    </div>
  )
}
